export const getBullyingDefence = async () => {
  const url = `${process.env.NEXT_PUBLIC_STRAPI}/api/biases?filters[biasUses][type][$eq]=Bullying%20Defence&populate=*&pagination[limit]=105`;
  return await fetch(url).then(data => data.json());
};
